import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFork"><Path fillRule="evenodd" clipRule="evenodd" d="M6.85976 2V12.125C6.85976 12.8844 7.4351 13.5 8.14481 13.5C8.85453 13.5 9.42987 12.8844 9.42987 12.125V2H10.8318V12.25C10.8318 12.9404 11.3548 13.5 12 13.5C12.6452 13.5 13.1682 12.9404 13.1682 12.25V2H14.5701V12.125C14.5701 12.8844 15.1455 13.5 15.8552 13.5C16.5649 13.5 17.1403 12.8844 17.1403 12.125V2L18.5422 2L19.5 15.2742L15.7384 19.4947V22H8.26163V19.4947L4.5 15.2742L5.45787 2L6.85976 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFork;
